import { render, staticRenderFns } from "./TruckValueTab.vue?vue&type=template&id=b1df0be6&scoped=true"
import script from "./TruckValueTab.vue?vue&type=script&lang=js"
export * from "./TruckValueTab.vue?vue&type=script&lang=js"
import style0 from "./TruckValueTab.vue?vue&type=style&index=0&id=b1df0be6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1df0be6",
  null
  
)

export default component.exports